import React, { useEffect, useState } from 'react'
import { InputText } from 'primereact/inputtext';
import { Sidebar } from 'primereact/sidebar';

import ProSetupForm from '../../components/setup/ProSetupForm';
import ProDuplicateForm from '../../components/setup/ProDuplicateForm';
import ProMultiSelect from '../../components/common/ProMultiSelect';
import ProTreeTable from '../../components/common/ProTreeTable';

import useTreeTemplateServices from '../../hooks/useTreeTemplateServices';
import useRolePermissionServices from '../../hooks/useRolePermissionServices';
import useFormServices from '../../hooks/useFormServices';
import useFormModelServices from '../../hooks/useFormModelServices';
import useSetup from '../../hooks/useSetup';
import { useHierarchyService } from '../../hooks/useHierarchyService';
import { useLocationServices } from '../../hooks/useLocationServices';
import { useDialogService } from '../../hooks/useDialogService';

import { Severity } from '../../constants/ProConstants';
import {capitalizeFirstLetter} from '../../utilities/Helper'
import _ from 'lodash'



const Setup = () => {  
    
    const {locations, isLocationsInitialized, primaryLocationId} = useLocationServices();
    const {data:{selectedLocations},actions:{ SetSelectedLocations,  DeleteNode}} = useSetup({refreshTree:true});
    const {GetSetupModel} = useFormModelServices();
    const {data:{SetupRoles}} = useRolePermissionServices();
    const {actions:{ShowDialog}} = useDialogService();

    const [toggleSideBar, setToggleSideBar] = useState(false);
    const [nodeModel, setNodeModel] = useState({})
    const [formAction, setFormAction] = useState('')
    const [toggleDuplicateSideBar, setToggleDuplicateSideBar] = useState(false);  
    const [searchValue, setSearchValue] = useState('');
    const { data:{tree, selectedTreeNode}, actions:{FilterLevelTypes, ParseHierarchy}} = useHierarchyService();
    const [defaultSelectionKey, setDefaultSelectionKey] = useState(_.get(tree, "length")> 0? tree[0].key : "");
    const {actions:{ UpdateFormState}} = useFormServices();
    
    useEffect(()=>{ 
        if(SetSelectedLocations && _.get(locations, "length") > 0){  
            if(_.isNull(selectedLocations)){                
                SetSelectedLocations(locations)            }
        }
    }, [locations,selectedLocations, primaryLocationId, SetSelectedLocations]) 

    useEffect(()=>{
        return ()=>{  
            UpdateFormState(false)                   
        }
    }, [])

   
    const performAction = async (operation) => {        
        switch (operation) {
            case "ADD":
                FilterLevelTypes(selectedTreeNode)
                ParseHierarchy(true)
                setNodeModel({});
                setFormAction("ADD");
                setToggleSideBar(prev => !prev)
                break;
            case "EDIT":
                ParseHierarchy(false)
                setNodeModel(await GetSetupModel(selectedTreeNode))
                setFormAction(operation);
                setToggleSideBar(prev => !prev)
                break;
            case "DELETE":               
                var body =   `This action is permanent.\n\nAre you sure you want to proceed?`
                var labelOk = "Proceed with Delete";
                var labelCancel = "Cancel"
                await ShowDialog(`Delete ${capitalizeFirstLetter(selectedTreeNode.type)} ${selectedTreeNode.label}`, body, "pi pi-trash", labelOk, labelCancel, Severity.Danger,
                ()=>{
                    DeleteNode(selectedTreeNode);
                    setDefaultSelectionKey(selectedTreeNode.parentId)
                }, 
                ()=>{console.log("Cancel Action")});
                break;           
            case "DUPLICATE":
                setNodeModel(await GetSetupModel(selectedTreeNode))
                setFormAction("DUPLICATE");
                setToggleDuplicateSideBar(true)
                break;  
            case "CANCEL":
                setNodeModel({});
                setFormAction("CANCEL");
                setToggleSideBar(false);
                setToggleDuplicateSideBar(false)
                break;        
            default:
                break
               
        }
    }
    const searchOnChange = (value) => {
        setSearchValue(value)
    }

    const {data: {SetupTableConfig}, actions :{OnTreeNodeSelect}} = useTreeTemplateServices({performAction, activePage:"SETUP"}); 

    return (<div>
        <div className='header-row'>
            <div className="search-box">
                <span className="p-input-icon-left">
                    <i className="pi pi-search" />
                    <InputText className='search-bar-input' onChange={(e) => searchOnChange(e.target.value)} placeholder="Search" />
                </span>
            </div> 
            <div>
                <ProMultiSelect value={selectedLocations} options={locations} onChange={SetSelectedLocations}/>
            </div>          
            <div className='add-btn'>
               { SetupRoles.canModify && !_.isEqual(_.get(selectedTreeNode, "type"), "BED") && <div className='btn-plus' onClick={()=>performAction("ADD")}>
                    <i className="pi pi-plus" /> Add
                </div>}
                <Sidebar dismissable={false} modal={false}
                    visible={toggleSideBar} position="right"
                    style={{ width: '30em' }} onHide={() => setToggleSideBar(false)} icons={() => (
                        <h6 className="p-sidebar-close"
                            style={{ fontWeight: '700', fontSize: '20px', width: '100%', margin: 'auto' }}>{(_.isEqual(formAction, "EDIT") && !_.isEmpty(nodeModel))? `Edit ${nodeModel.type.name}` : "Add New"  }</h6>
                    )}>

                    <ProSetupForm formModel={nodeModel} formAction={formAction} showFooter={true} closeSideBar={(e) => {performAction("CANCEL") }} />
                </Sidebar>              
            </div>
            {nodeModel && nodeModel.model && nodeModel.model.name && (
            <Sidebar dismissable={false} modal={false}
                    visible={toggleDuplicateSideBar} position="right"
                    style={{ width: '30em' }}
                    onHide={() => setToggleDuplicateSideBar(false)} icons={() => (
                        <h6 className="p-sidebar-close" style={{ fontWeight: '700', fontSize: '20px', width: '100%', margin: 'auto' }}>
                            Duplicate {nodeModel.type.name}
                        </h6>
                    )}>
                    <ProDuplicateForm
                        formModel={nodeModel}
                        formAction={formAction}
                        showFooter={true}
                        closeSideBar={() => performAction("CANCEL")}
                    />
            </Sidebar>
            )}
 
        </div>
        <div>
            <div className='data-row'>              
                <div className="p-col-16 p-lg-12">                   
                   { (tree && tree.length > 0)  &&<ProTreeTable index={2} treeData={tree} defaultSelectionKey={defaultSelectionKey}   searchValue={searchValue} config={SetupTableConfig} OnTreeNodeSelect={OnTreeNodeSelect}  />
                    
                 }
                  {(isLocationsInitialized && _.get(selectedLocations, "length") === 0) && <div>No Records found</div>}
                </div>               
            </div>
        </div>
    </div>)

}

export default Setup;